module.exports = __webpack_public_path__ + "c59e9473630dd4ebec51c1e3aca18f8d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/owl-item-types/greetings.png
// module id = 1140
// module chunks = 0